import React from 'react';

function WinnerItem(props) {
  const { winner, profile, contest } = props;

  return (
    <div className="card">
      <div className="card-content">
        <p>User Id: {winner.userId}</p>
        <p>UserName: {profile ? profile.userName : ''}</p>
        <p>Email: {profile ? profile.email : ''}</p>
        <p>Country: {profile ? profile.countryCode : ''}</p>
        <p>Contest Name: {contest ? contest.name : ''}</p>
        <p>Contest Id: {winner.contestId}</p>
      </div>
    </div>
  );
}

export default WinnerItem;
